import styled from "styled-components";
import Header from "./Header";
import DisplayMessage from "./DisplayMessage";
import AllFilters from "./AllFilters";
import Cards from "./Cards";

const DashboardWrapper = styled.div`
  width: 100%;
  height: 1050px;
  margin: 0 auto;
  background-color: #fff;
`;

const MainContentWrapper = styled.div`
  width: 1130px;
  height: auto;
  margin: 0 auto;
`;

function App() {
  return (
    <DashboardWrapper>
      <Header />
      <MainContentWrapper>
        <DisplayMessage />
        <AllFilters />
        <Cards />
      </MainContentWrapper>
    </DashboardWrapper>
  );
}

export default App;
